import BatchJobList from '../components/BatchJobList.vue';
import BatchJobDetail from '../components/BatchJobDetail.vue';
import BatchJobDetailCrawl from '../components/BatchJobDetailCrawl.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User'],
  },
  {
    path: 'list',
    component: BatchJobList,
    meta: {
      title: 'Batch Jobs',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/batch-jobs',
          title: 'Batch Jobs',
        },
        {
          path: '',
          title: 'View Batch Jobs',
        },
      ],
    },
  },
  {
    path: 'detail/:id',
    component: BatchJobDetail,
    meta: {
      title: 'Detail Batch Job',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/batch-jobs',
          title: 'Batch Jobs',
        },
        {
          path: '',
          title: 'View Detail',
          isDisplayId: true,
        },
      ],
    },
  },
  {
    path: 'detail-crawl/:id',
    component: BatchJobDetailCrawl,
    meta: {
      title: 'Detail Batch Job',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/batch-jobs',
          title: 'Batch Jobs',
        },
        {
          path: '',
          title: 'View Detail',
          isDisplayId: true,
        },
      ],
    },
  },
];
